module.exports = __webpack_public_path__ + "static/media/reference-slider-27.5ebd2357.jpg";